import React, { useState, useEffect } from 'react';
import { trackPromise } from 'react-promise-tracker';

import { useFormik } from 'formik';

import {
    cadastrarRemuneracaoGreenerBuyer,
    detalhesRemuneracaoGreenerBuyer,
    atualizarRemuneracaoGreenerBuyer,
    idRemuneracaoGreenerBuyer
} from '../../../../../services/http/buyerService'

import { useSnackBar } from '../../../../../hooks/snackBar';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import CurrencyTextField from '@unicef/material-ui-currency-textfield'

import './styles.scss';

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 48 * 4.5 + 8,
            width: 250
        }
    },
    getContentAnchorEl: null,
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
    },
    transformOrigin: {
        vertical: "top",
        horizontal: "center"
    },
    variant: "menu"
};

const FormRemuneracaoGreenerBuyer = ({
    handleCancelar,
    idEmpresa
}) => {
    
    const { addSnackBar } = useSnackBar();

    const [idRemuneracao, setIdRemuneracao] = useState('');

    const formik = useFormik({
        initialValues: ({
            tipo: 0,
            fee: '0',
            comissao: '0',
            membership: '0',
            status: 0
        }),
        onSubmit: (values) => {
            if (idRemuneracao) {
                atualizarRemuneracaoGreener(values);
            } else {
                salvarRemuneracaoGreeer(values);
            }
        }
    })

    useEffect(() => {
        buscarIdRemuneracaoGreener();
    },[])

    useEffect(() => {
        buscarRemuneracaoGreener();
    },[idRemuneracao])

    const buscarRemuneracaoGreener = () => {
        trackPromise(
            detalhesRemuneracaoGreenerBuyer(idRemuneracao)
                .then(res => {
                    if (!res.fail && res.data) {
                        formik.setValues(res.data);
                    }
                })
        ).catch(error => {
            console.log(error);
            addSnackBar({
                message: 'Erro ao buscar remuneração Greener',
                info: 'error',
                open: true
            });
        })
    }

    const atualizarRemuneracaoGreener = (values) => {
        let data = {
            fee: values.fee,
            comissao: values.comissao,
            membership: values.membership,
            status: values.status,
            tipo: values.tipo
        }

        trackPromise(
            atualizarRemuneracaoGreenerBuyer(idRemuneracao, data)
                .then(res => {
                    if (!res.fail) {
                        addSnackBar({
                            message: 'Alterado com sucesso',
                            info: 'success',
                            open: true
                        })

                        buscarIdRemuneracaoGreener();
                    }
                })
        ).catch(error => {
            console.log(error);
            addSnackBar({
                message: 'Erro ao tentar atualizar remuneração Greener',
                info: 'error',
                open: true
            })
        })
    }

    const salvarRemuneracaoGreeer = (values) => {

        let data = {
            fee: values.fee,
            comissao: values.comissao,
            membership: values.membership,
            status: values.status,
            tipo: values.tipo
        }

        trackPromise(
            cadastrarRemuneracaoGreenerBuyer(idEmpresa, data)
                .then(res => {
                    if (!res.fail) {
                        addSnackBar({
                            message: 'Alterado com sucesso',
                            info: 'success',
                            open: true
                        });

                        buscarIdRemuneracaoGreener();
                    }
                })
        ).catch(error => {
            console.log(error);
            addSnackBar({
                message: 'Erro ao tentar salvar remuneração Greener',
                infor: 'error',
                open: true
            })
        })
    }

    const buscarIdRemuneracaoGreener = () => {
        trackPromise(
            idRemuneracaoGreenerBuyer(idEmpresa)
                .then(res => {
                    if (!res.fail && res.data) {
                        setIdRemuneracao(res.data);
                    }
                })
        ).catch(error => {
            console.log(error);
        })
    }

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className='row'>
                <div className='col-sm-12 col-md-12 col-lg-12 descricao'>
                    <h1 className='label-second'>Contrato Greeners</h1>
                </div>
                <div  className="col-sm-2 col-md-2 col-lg-2 mt20">
                    <FormControl>
                        <InputLabel id="demo-simple-select-helper-label">Status</InputLabel>
                        <Select
                            required
                            className="select"
                            variant="outlined"
                            id="status"
                            value={formik.values.status}
                            label="Status"
                            onChange={formik.handleChange('status')}
                            MenuProps={MenuProps}
                            error={formik.touched.status && Boolean(formik.errors.status)}
                        >
                            <MenuItem disabled={true} value={0}>
                                <em>Selecione o status</em>
                            </MenuItem>
                            <MenuItem value={1}>Pendente</MenuItem>
                            <MenuItem value={2}>Ativo</MenuItem>
                            <MenuItem value={3}>Inativo</MenuItem>
                        </Select>
                    </FormControl>
                </div>
                <div  className="col-sm-2 col-md-2 col-lg-2 mt20">
                    <FormControl>
                        <InputLabel id="demo-simple-select-helper-label">Tipo</InputLabel>
                        <Select
                            required
                            className="select"
                            variant="outlined"
                            id="tipo"
                            value={formik.values.tipo}
                            label="Tipo"
                            onChange={formik.handleChange('tipo')}
                            MenuProps={MenuProps}
                            error={formik.touched.tipo && Boolean(formik.errors.tipo)}
                        >
                            <MenuItem disabled={true} value={0}>
                                <em>Selecione o tipo</em>
                            </MenuItem>
                            <MenuItem value={1}>Pré-Pago</MenuItem>
                            <MenuItem value={2}>Pós-Pago</MenuItem>
                        </Select>
                    </FormControl>
                </div>
                <div className='col-sm-12 col-md-12 col-lg-12 font mt20'>
                    <strong>Remuneração</strong>
                </div>
                <div  className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                        <CurrencyTextField 
                            label="Fee"
                            type="text" 
                            size="small"
                            id="fee" 
                            variant="outlined"
                            currencySymbol="R$"
                            decimalCharacter=","
			                digitGroupSeparator="."
                            value={formik.values.fee || "0"}
                            onChange={(event, value) => formik.setFieldValue('fee', value)}
                            error={formik.touched.fee && Boolean(formik.errors.fee)}
                            helperText={formik.touched.fee && formik.errors.fee}
                        />
                    </FormControl>
                </div>

                <div  className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                        <CurrencyTextField 
                            label="Comissão"
                            type="text" 
                            size="small"
                            id="comissao" 
                            variant="outlined"
                            currencySymbol="%"
                            decimalCharacter="."
                            maximumValue="100"
                            value={formik.values.comissao || "0"}
                            onChange={(event, value) => formik.setFieldValue('comissao', value)}
                            error={formik.touched.comissao && Boolean(formik.errors.comissao)}
                            helperText={formik.touched.comissao && formik.errors.comissao}
                        />
                    </FormControl>
                </div>

                <div  className="col-sm-4 col-md-4 col-lg-4">
                    <FormControl>
                        <CurrencyTextField 
                            label="Membership"
                            type="text" 
                            size="small"
                            id="membership" 
                            variant="outlined"
                            currencySymbol="R$"
                            decimalCharacter=","
			                digitGroupSeparator="."
                            value={formik.values.membership || "0"}
                            onChange={(event, value) => formik.setFieldValue('membership', value)}
                            error={formik.touched.membership && Boolean(formik.errors.membership)}
                            helperText={formik.touched.membership && formik.errors.membership}
                        />
                    </FormControl>
                </div>

                <div className="col-sm-12 col-md-12 col-lg-12  flex flex-end buttons mt40">
                    <button 
                        className="col-sm-3 col-md-3 col-lg-3 buton-white-black-border"
                        onClick={handleCancelar}
                    >
                        CANCELAR
                    </button>
                    <button
                        className="col-sm-3 col-md-3 col-lg-3 buton-green"
                        type="submit"
                    >
                        SALVAR
                    </button>
                </div>
            </div>
            
        </form>
    )
}

export default FormRemuneracaoGreenerBuyer;